import { MessageCircle } from "lucide-react";
import { openChittiChat } from "@/lib/analytics";

const BASE =
  "inline-flex items-center justify-center gap-2.5 rounded-full font-semibold uppercase tracking-[0.12em] transition-[transform,box-shadow,background-color,border-color] duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1C6B52] focus-visible:ring-offset-2 focus-visible:ring-offset-[#080705] active:scale-[0.98]";

const SIZES = {
  lg: "min-h-[56px] px-9 text-sm sm:text-base",
  md: "min-h-[48px] px-6 text-xs sm:text-sm",
  sm: "min-h-[44px] px-5 text-xs",
};

// ============================================================================
// ASK CHITTI BUTTON — the "Visitor -> Ask Chitti -> Chitti AI -> qualification
// -> BookMyShow" entry point. Routes through analytics.js's openChittiChat,
// which uses the SAME WhatsApp number and WATI-powered Chitti AI agent
// already live on the site — this component is a visual entry point only,
// no new backend/number. Styled in the brand's documented-but-rarely-used
// emerald accent (the same tone already used for the "Official Partner"
// trust badge in TicketsV2) so it reads as "instant / verified help" and is
// visually distinct from the gold "Tickets Are Live" buttons, never
// competing with them for primary attention.
// ============================================================================
export function AskChittiButton({
  location,
  label = "Ask Chitti AI",
  size = "md",
  className = "",
  testId,
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={`${label} — opens WhatsApp`}
      onClick={() => openChittiChat(location)}
      className={`${BASE} ${SIZES[size]} border border-[#1C6B52]/60 bg-[#0D3B2E]/25 text-[#8FD9BE] backdrop-blur-sm hover:border-[#1C6B52] hover:bg-[#0D3B2E]/45 hover:text-[#B7EAD3] ${className}`}
    >
      <MessageCircle className="h-4 w-4 shrink-0" aria-hidden="true" />
      {label}
    </button>
  );
}
